export default __webpack_public_path__ + "static/media/bootstrap-reboot.rtl.css.8534eb47.map";